import { Observable } from 'rxjs';

import { ViLPRProvider } from '@lib/vehicle-intelligence/shared';

import { LprWarningEntry } from '../../constants/errors';
import { IFsHistoricalProviderResultsInterface } from './historical-provider-results';
import { LPRResultsFacets } from './lpr-results-facets';
import { IFsLprParameters } from './parameters';
import { IFsLprResult } from './result';

export interface IFsLprProviderInterface {
  // name to display for tab
  name: string;

  // Optional enum-based name for SDM code to use when feature flag is enabled
  // When SDM is enabled, providers should set both name (string) and nameEnum (enum)
  nameEnum?: ViLPRProvider;

  // Initialize the provider
  init(): void;

  search(params: Partial<IFsLprParameters>): void;

  // Get historical results for a given provider
  getHistoricalResults(
    params: Partial<IFsLprParameters>,
  ): Observable<IFsHistoricalProviderResultsInterface>;

  // provider should store parameters and handle navigating to a next page, assume that a new search will reset this paging
  next(): void;

  // cancel the search
  cancel(): void;

  // all results that have been loaded by the provider
  results: IFsLprResult[];
  facets?: LPRResultsFacets;

  // total number of results for this provider
  total: number;

  // are we loading
  isLoading: boolean;

  // no more pages to load
  isFinished: boolean;

  // blocking issues that prevent searching
  errors: string[];

  // non-blocking limitations (i.e. unused unsupported filters)
  warnings: LprWarningEntry[];

  // have we loaded any results
  loaded$: Observable<boolean>;
}
